import { PieChart, Pie, Cell } from 'recharts';
import { ChartsFreeText } from '../../../components';
import PieLabel from './PieLabel';
import { ReportWorkderMonthlyEnqueteDataGraphs } from '../../../types/report';
import { useEnqueteMonthlyPieStyles } from '../../../assets/styles/Report.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  data: ReportWorkderMonthlyEnqueteDataGraphs[];
};

/**
 *
 *
 *
 * @method Component
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const ReportMonthlyEnquetePie = (props: Props) => {
  const { data } = props;
  const classes = useEnqueteMonthlyPieStyles();
  const totalCount = data.reduce((prev, current) => prev + current.count, 0);
  const warningCount = data.reduce(
    (prev, current) => (current.answer >= 4 ? prev + current.count : prev),
    0,
  );

  data.sort(
    (
      a: ReportWorkderMonthlyEnqueteDataGraphs,
      b: ReportWorkderMonthlyEnqueteDataGraphs,
    ) => (a.answer < b.answer ? 1 : -1),
  );

  return (
    <PieChart className={classes.pie} width={200} height={180}>
      <Pie
        data={data}
        dataKey="count"
        nameKey="answer"
        innerRadius={43}
        outerRadius={70}
        startAngle={90}
        endAngle={-270}
        label={<PieLabel />}
        labelLine={false}
      >
        {data.map((e, index) => (
          <Cell key={index} fill={e.answer >= 4 ? '#5C5B5B' : '#E9E8E8'} />
        ))}
      </Pie>

      <g>
        <ChartsFreeText
          x={'50%'}
          y={'50%'}
          text={`${((warningCount / totalCount) * 100).toFixed(0)}`}
          textUnit="%"
          textAnchor={'middle'}
          fontSize={28}
          color="#7A7A7A"
        />
      </g>
    </PieChart>
  );
};

export default ReportMonthlyEnquetePie;
